
import React from 'react';
import AIGeneratedImage from './AIGeneratedImage';

const INDUSTRIES = [
  { 
    name: 'Finance & Banking', 
    prompt: 'Futuristic digital banking vault with floating holographic gold particles and security lasers, high-tech interior, obsidian and cyan lighting',
    code: 'SEC-FIN'
  },
  { 
    name: 'Government & Defense', 
    prompt: 'Ultra-modern military command center with transparent holographic tactical maps, futuristic soldiers in sleek armor, cinematic atmosphere',
    code: 'SEC-GOV'
  },
  { 
    name: 'Healthcare Systems', 
    prompt: 'Advanced bio-digital hospital room, robotic surgery arms, glowing DNA holograms, clean white and clinical blue aesthetics',
    code: 'SEC-MED'
  },
  { 
    name: 'Quantum Commerce', 
    prompt: 'A quantum-powered shopping district with floating delivery drones and holographic storefronts, night scene with vibrant neon reflections',
    code: 'SEC-QCM'
  },
];

const Industries: React.FC = () => {
  return (
    <section id="industries" className="py-40 relative overflow-hidden scroll-mt-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-24 gap-12">
          <div className="space-y-6">
            <h2 className="text-brand-400 font-mono text-[11px] font-black uppercase tracking-[0.5em]">OPERATIONAL THEATERS</h2>
            <h3 className="text-5xl md:text-7xl font-black text-white tracking-tighter">Sector Dominance.</h3>
          </div>
          <p className="text-slate-400 max-w-md text-lg font-light leading-relaxed">
            Specialized defensive matrices designed for high-stakes verticals where every millisecond is a vulnerability.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {INDUSTRIES.map((ind) => (
            <div key={ind.name} className="relative group overflow-hidden rounded-[3rem] aspect-[3/4.5] border border-white/5 shadow-2xl bg-black">
              <AIGeneratedImage 
                prompt={ind.prompt}
                alt={ind.name}
                aspectRatio="3:4"
                className="absolute inset-0 w-full h-full"
              />
              
              <div className="absolute inset-0 bg-gradient-to-t from-[#010208] via-[#010208]/20 to-transparent z-10" />
              <div className="absolute inset-0 border border-white/0 group-hover:border-brand-500/20 transition-all rounded-[3rem] m-4 z-20" />

              <div className="absolute top-8 left-8 z-20">
                <div className="text-[10px] font-mono font-black text-brand-400/60 uppercase tracking-[0.3em]">{ind.code}</div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-10 z-20">
                <h4 className="text-2xl font-black text-white group-hover:text-brand-400 transition-colors leading-tight mb-4">{ind.name}</h4>
                <div className="w-12 h-1 bg-brand-500 rounded-full scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500 shadow-[0_0_15px_rgba(14,140,233,1)]" />
                
                <p className="mt-6 text-[10px] text-slate-500 uppercase font-bold tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  Access Secure Case Study →
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
